<div class="grid grid-cols-1" lohiPageTitle="Coaching">
  <div class="col-span-1 lg:col-span-2 grid grid-cols-4 m-3">
    <div class="col-span-4">
      <div class="card-with-shadow bg-white p-2" *ngIf="drivers$ | async as stats">
        <div class="flex items-center justify-between">
          <div class="text-lg font-bold">Driver Scorecard <span class="text-blue-500">Past 10 Shifts</span></div>
          <div>
            <button mat-stroked-button color="primary" (click)="promptAutopilotCoaching()">Autopilot</button>
          </div>
        </div>
        <div class="grid grid-cols-2 lg:grid-cols-6 lg:gap-2 gap-y-3 lg:gap-y-0 mt-3 items-center select-none">
          <div
            class="text-lg ml-2 font-bold text-gray-600 text-center cursor-pointer flex flex-row items-center"
            (click)="setSortHeader('avgRevenue')"
          >
            Rank
            <lohi-sort-indicator
              [activeColumn]="sortBy === 'avgRevenue'"
              [reversed]="sortReverse"
            ></lohi-sort-indicator>
          </div>
          <div
            class="text-lg font-bold text-gray-600 ml-2 cursor-pointer flex flex-row justify-start items-center"
            (click)="setSortHeader('user_name')"
          >
            Driver
            <lohi-sort-indicator [activeColumn]="sortBy === 'user_name'" [reversed]="sortReverse"></lohi-sort-indicator>
          </div>
          <div
            class="text-lg font-bold text-gray-600 text-center cursor-pointer flex flex-row items-center"
            (click)="setSortHeader('coachingMessage')"
          >
            Performance
            <lohi-sort-indicator
              [activeColumn]="sortBy === 'coachingMessage'"
              [reversed]="sortReverse"
            ></lohi-sort-indicator>
          </div>
          <div class="text-lg font-bold text-gray-600 text-center cursor-pointer flex flex-row items-center">Coach</div>
          <div
            class="text-lg font-bold text-gray-600 text-center flex flex-row justify-center items-center"
            (click)="setSortHeader('lost_earnings')"
          >
            Earnings Past 10 Shifts
            <lohi-sort-indicator
              [activeColumn]="sortBy === 'lost_earnings'"
              [reversed]="sortReverse"
            ></lohi-sort-indicator>
          </div>
          <div
            class="text-lg font-bold text-gray-600 text-center cursor-pointer flex flex-row justify-end items-center"
            (click)="setSortHeader('avgRevenue')"
          >
            Revenue Per Shift
            <lohi-sort-indicator
              [activeColumn]="sortBy === 'avgRevenue'"
              [reversed]="sortReverse"
            ></lohi-sort-indicator>
          </div>
        </div>
        <a
          [routerLink]="['/drivers', driver.UserId]"
          *ngFor="let driver of stats; trackBy: 'UserID' | trackByKey"
          class="grid gap-2 grid-cols-2 lg:grid-cols-6 items-center py-3 even:bg-gray-200"
        >
          <div class="text-lg ml-2">
            <ng-container *ngIf="ranks$ | async as ranks">
              {{ ranks[driver.UserId] || '' }}
            </ng-container>
          </div>
          <div class="text-lg font-bold ml-2 flex flex-row justify-between items-center">
            {{ driver.user_name }}
          </div>
          <div class="capitalize">{{ driver.coachingMessage }}</div>
          <div routerLink="" class="flex flex-col">
            <div>
              <a
                *ngIf="driver.coachingMessage"
                [routerLink]="['/drivers', driver.UserId]"
                [queryParams]="{ coaching: driver.coachingCategory }"
                type="button"
                mat-stroked-button
                color="primary"
                >Lola Coaching</a
              >
              <div class="text-gray-600" *ngIf="driver.lastCoachedAt">
                Last Coached {{ driver.lastCoachedAt | ago }}
              </div>
            </div>
          </div>
          <div class="flex flex-col justify-center items-center">
            <lohi-driver-spark-line
              [earningsPerDay]="driver.driver_earnings_per_day"
              [id]="driver.UserId"
              [driverID]="driver.UserId"
              [driverTarget]="(targets$ | async)[driver.UserId]"
            ></lohi-driver-spark-line>
          </div>
          <div class="text-lg text-right">{{ driver.avgRevenue | currencyInPennies }}</div>
        </a>
      </div>
    </div>
  </div>
</div>

<ng-template #autopilotCoachingRequest>
  <div mat-dialog-title>Autopilot Coaching</div>
  <div mat-dialog-content>Request an invite to the limited Coaching Autopilot Beta.</div>
  <div mat-dialog-actions class="flex justify-between">
    <button mat-button mat-dialog-close>Close</button>
    <button mat-raised-button mat-dialog-close color="primary" (click)="requestInvite()">Request Invite</button>
  </div>
</ng-template>
